<template>
  <div class="adminView">
    <section class="adminView__detail">
      <router-view/>
    </section>
  </div>
</template>

<style scoped lang="scss">
.adminView {
  width: 100%;
  text-align: left;

  &__detail {
    min-width: 0;
  }
}
</style>
